import React from "react";
import  './dataProjects.scss';
import { BLOCKS } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

export interface IDataProjectsProps {
	title: string;
	cards: [
		{
			image: string;
			title: string;
            descripcion: { json: any };
		}
	]
}

const DataProjects = (props: IDataProjectsProps) =>{

	const {title, referenciaPlantillaContenido:cards } = props;
    const RenderOptions = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, children) => {
                return <p>{children}</p>;
            }
        },
    };
	
    return (
		<div className="m-dataProjects">
			<div className="m-dataProjects__content">
				<h2 className="m-dataProjects__title">{title}</h2>
				<div className="m-dataProjects-items">
					{cards.map((content:any) => (
						<>
							{
								content.fields ? (
									<div className="m-dataProjects-items__item">
										<img className='m-dataProjects-items__item__image' src={content.fields.imagenPrincipal[0].fields.file.url} ></img>
										<p className="m-dataProjects-items__item__title">
											{content.fields.tituloDescripcion}
										</p>
										<p className="m-dataProjects-items__item__description">
											{content.fields.descripcion.json.content[0].content[0].value}
										</p>
									</div>
								):(
									<div className="m-dataProjects-items__item">
										<img className='m-dataProjects-items__item__image' src={content.imagenPrincipal[0].file.url} ></img>
										<p className="m-dataProjects-items__item__title">
											{content.tituloDescripcion}
										</p>
										<p className="m-dataProjects-items__item__description">
											{content.descripcion.json.content[0].content[0].value}
										</p>
									</div>
								)
							}
						
						</>
					))}
				</div>
			</div>
		</div>
    
    )
}


export default DataProjects

